module.exports = __webpack_public_path__ + "static/media/CARACOLVER_MENU-normal.8ccb0c77.png";